interface HeaderProps {
  onCtaClick: () => void;
}

export default function Header({ onCtaClick }: HeaderProps) {
  return (
    <header
      className="w-full flex items-center justify-between px-8"
      style={{
        background: "#0A0A0A",
        height: "72px",
        borderBottom: "1px solid rgba(201, 149, 111, 0.15)",
      }}
    >
      {/* Logo */}
      <div className="flex items-center h-full py-2.5">
        <img
          src="https://static.readdy.ai/image/b1af610ebea9d5dff7bba4d7db421a2d/efa59382ce49994f108d3b6dc4f24e13.png"
          alt="Capital Growth Studio"
          className="h-full object-contain"
          style={{ maxWidth: "180px" }}
        />
      </div>

      {/* CTA Button */}
      <button
        onClick={onCtaClick}
        className="whitespace-nowrap flex items-center gap-2 font-semibold text-white text-sm px-6 py-2.5 rounded-full cursor-pointer transition-all duration-300 hover:scale-105 active:scale-95"
        style={{
          background: "linear-gradient(135deg, #C9956F 0%, #B07048 100%)",
          fontFamily: "'Inter', sans-serif",
          boxShadow: "0 4px 16px rgba(176, 112, 72, 0.35)",
        }}
      >
        <i className="ri-calendar-check-line text-sm" />
        Get My Free Audit
      </button>
    </header>
  );
}
